















































































import { Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, Picture } from '@/components/atoms';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import BillingModel from '@/views/Models/BillingModel.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';

type Variants = {
  default: Variant;
  mobileModal: Variant;
  mobileEmptyState: Variant;
};

type Variant = {
  imgSize: string;
  title: TypographyProps;
  description: TypographyProps;
};

type TypographyProps = {
  fontWeight?: string;
  fontSize?: string;
  lineHeight?: string;
  color?: string;
};

@Component({
  components: {
    Surface,
    Typography,
    Picture,
    FilledButton,
    CoinNetworkFeatureTag
  }
})
export default class SocialRewardsDescription extends BillingModel {
  @Prop(String) readonly button?: string;
  @Prop({ default: 'default' }) readonly category!:
    | 'default'
    | 'mobileModal'
    | 'mobileEmptyState';
  @Prop(Boolean) readonly isEmptyState?: string;
  @Prop(Boolean) readonly loadingClick?: string;

  variants: Variants = {
    default: {
      imgSize: '271px',
      title: { fontSize: '28px', fontWeight: '600', lineHeight: '32px' },
      description: { fontSize: '16px', fontWeight: '400', lineHeight: '24px' }
    },
    mobileModal: {
      imgSize: '240px',
      title: { fontSize: '20px', fontWeight: '600', lineHeight: '28px' },
      description: { fontSize: '16px', fontWeight: '400', lineHeight: '24px' }
    },
    mobileEmptyState: {
      imgSize: '271px',
      title: { fontSize: '32px', fontWeight: '600', lineHeight: '36px' },
      description: {
        fontSize: '16px',
        fontWeight: '400',
        lineHeight: '24px'
      }
    }
  };
}
